import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import './../shared/rxjs-operators';
import { LogService } from './';

@Injectable()
export class CacheService {

  constructor(private logger: LogService) {
    this.logger.log('cache.service', 'constructor', 'hello');
  }

  get(key: string): Observable<any> {
    let promise = this.getFromCache(key);
    let cache = Observable.fromPromise(promise);
    let subscription = cache.subscribe(
      (x) => { },
      (e) => { console.log('e', e); },
      () => { console.log('complete'); }
    );

    return cache;
  }

  getFromCache(key: string): Promise<any> {
    this.logger.log('cache.service', 'getFromCache', key);
    return new Promise((resolve, reject) => {
      let value = localStorage[key] || null; // || reject('not in cache');
      resolve(JSON.parse(value));
    });
  }

  updateCache(key: string, source: Observable<any>) {
    let subscription = source.subscribe(
      (x) => {
        if (x !== null) {
          localStorage[key] = JSON.stringify(x);
        }
      },
      (e) => { },
      () => { }
    );

  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/cache.service.ts